var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoin2 = function SvgCoin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "16 14 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 19.67a29.51 29.51 0 1 0 29.7 29.5 29.6 29.6 0 0 0-29.7-29.5m0 55.71a26.21 26.21 0 1 1 26.38-26.21A26.32 26.32 0 0 1 49.5 75.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 39.34a9.84 9.84 0 1 0 9.9 9.83 9.86 9.86 0 0 0-9.9-9.83m0 16.55a6.72 6.72 0 1 1 6.76-6.72 6.74 6.74 0 0 1-6.76 6.72"
  })));
};
export default SvgCoin2;